<div class="ra-memo-content-wrapper" id='idMemoContentMobile'>
    <div class="ra-memo-sec" data-sec="idBasicInfo">
        <div class="ra-memo-sec-row-title"><h3>基本資料</h3></div>
        <div class="ra-memo-sec-row-data colorA">
            <p class='ra-memo-value'><span class='ra-confirm-icon'></span> 已同意個資聲明內容</p>
        </div>
        <div [ngClass]="{jsMsgBox: chat.gender==''}" class="jsMsgBox0 " data-memo-group="idGender-Ans">
            <div class="ra-memo-sec-row-data colorB">
                <p class='ra-memo-label'>性別：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="idAnsGender">女生</span>-->
                    <span *ngIf="chat.gender=='b'">男生</span>
                    <span *ngIf="chat.gender=='g'">女生</span>
                </p>
            </div>
        </div>
        <div [ngClass]="{jsMsgBox: !chatStatus.ageNow}"  class="jsMsgBox0 " data-memo-group="idAge-Ans">
            <div class="ra-memo-sec-row-data colorA">
                <p class='ra-memo-label'>年齡：</p>
                <p class='ra-memo-value'>
                    <span data-id="idAnsAge">{{chat.ageNow}}</span>歲
                </p>
            </div>
        </div>
        <div [ngClass]="{jsMsgBox: chat.industry==''}" class="jsMsgBox0 " data-memo-group="idJob-Ans">
            <div class="ra-memo-sec-row-data colorB">
                <p class='ra-memo-label'>行業：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="idAnsJob">公共行政及國防；強制性社會安全</span>-->
                    <span data-id="idAnsJob">{{chat.industry_text}}</span>
                </p>
            </div>
        </div>
        <div [ngClass]="{jsMsgBox: !chatStatus.salary}" class="jsMsgBox0 " data-memo-group="idSalary-Ans">
            <div class="ra-memo-sec-row-data colorA">
                <p class='ra-memo-label'>薪資收入：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="idAnsSalary">50,000</span>元-->
                    <span data-id="idAnsSalary">{{chat.salary|number}}</span>元
                </p>
            </div>
        </div>
        <div [ngClass]="{jsMsgBox: !chatStatus.ageRetire}" class="jsMsgBox0 " data-memo-group="idRetireAge-Ans">
            <div class="ra-memo-sec-row-data colorB">
                <p class='ra-memo-label'>希望退休年齡：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id='idAnsRetireAge'>65</span>歲-->
                    <span data-id='idAnsRetireAge'>{{chat.ageRetire}}</span>歲
                </p>
            </div>
        </div>
    </div>
    <div class="ra-memo-sec" data-sec="idRetireInfo">
        <div [ngClass]="{jsMsgBox: !chatStatus.saveSum}" class="jsMsgBox0 " data-memo-group="idRetireTotalSimple-Ans">
            <div class="ra-memo-sec-row-title"><h3>退休規劃</h3></div>
            <div class="ra-memo-sec-row-data colorA">
                <p class='ra-memo-label'>退休金總額：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="">22,020,000</span>元-->
                    <span data-id="">{{chat.retireTotal|number:'1.0-0'}}</span>元
                </p>
            </div>
        </div>
        <div [ngClass]="{jsMsgBox: !chatStatus.saveSum}" class="jsMsgBox0 " data-memo-group="idSave-Ans">
            <div class="ra-memo-sec-row-data colorB">
                <p class='ra-memo-label'>已累積存款：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="">2,780,000</span>元-->
                    <span data-id="">{{chat.saveSum|number}}</span>元
                </p>
            </div>
        </div>
        <div [ngClass]="{jsMsgBox: !chatStatus.saveMth}" class="jsMsgBox0 " data-memo-group="idInvest-Ans">
            <div class="ra-memo-sec-row-data colorA">
                <p class='ra-memo-label'>每月儲蓄/投資：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="">6,000</span>元-->
                    <span data-id="">{{chat.saveMth|number}}</span>元
                </p>
            </div>
        </div>
        <div [ngClass]="{jsMsgBox: chat.laborInsurance==null}" class="jsMsgBox0 " data-memo-group="idLaborInsure-Ans">
            <div class="ra-memo-sec-row-data colorB">
                <p class='ra-memo-label'>勞工退休金：</p>
                <p class='ra-memo-value'><span data-id="">{{chat.laborPension?'':'不'}}列入</span>規劃</p>
            </div>
            <div class="ra-memo-sec-row-data colorA">
                <p class='ra-memo-label'>勞工保險金：</p>
                <p class='ra-memo-value'><span data-id=''>{{chat.laborInsurance?'':'不'}}列入</span>規劃</p>
            </div>
        </div>
        <div [ngClass]="{jsMsgBox: !chatStatus.saveMth}" class="jsMsgBox0 " data-memo-group="idLaborInsure-Ans">
            <div class="ra-memo-sec-row-data colorB">
                <p class='ra-memo-label'>退休金淨額：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="">6,000,000</span>元-->
                    <span *ngIf="chat.retireNet>0" data-id="">{{chat.retireNet|number:'1.0-0'}}元</span>
                    <span *ngIf="chat.retireNet<=0" data-id="">已足夠</span>
                </p>
            </div>
        </div>
    </div>
    <div class="ra-memo-sec ra-memo-sec-last" data-sec="idPersonalInfo">
        <div [ngClass]="{jsMsgBox: chat.mail==''}" class="jsMsgBox0 " data-memo-group="idPersonalInfo-Ans">
            <div class="ra-memo-sec-row-title"><h3>聯絡資訊</h3></div>
            <div class="ra-memo-sec-row-data colorA">
                <p class='ra-memo-label'>姓名：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="">王安聯</span>-->
                    <span data-id="">{{chat.name}}</span>
                </p>
            </div>
            <div class="ra-memo-sec-row-data colorB">
                <p class='ra-memo-label'>行動電話：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="">0912345678</span>-->
                    <span data-id="">{{chat.phone}}</span>
                </p>
            </div>
            <div class="ra-memo-sec-row-data colorA" style="margin-bottom: 20px;">
                <p class='ra-memo-label'>電子信箱：</p>
                <p class='ra-memo-value'>
                    <!--<span data-id="">abc@allianz.com</span>-->
                    <span data-id="">{{chat.mail}}</span>
                </p>
            </div>
        </div>
    </div>
    <!-- 全部作答完就不出現!! -->
    <a *ngIf="chat.mail==''" class="jsRobotContinue" routerLink="/thx/submit"
         style="width: 100%;">
        <div class="ra-memo-robot-footer"></div>
    </a>
</div>
